import React, { useContext, useEffect, useState } from "react";
import "./events.css";
import { CiLocationOn } from "react-icons/ci";
import { NavLink } from "react-router-dom";
import Location from "../../Location";
import { toast } from "react-toastify";
import { server, truncateText } from "../../common";
import { AxiosError } from "axios";
import { FcCalendar } from "react-icons/fc";
import { FcClock } from "react-icons/fc";
import configContext from "../../context/configContext/configContext";

const Events = () => {
  const [events, setEvents] = useState([]);
  const [industryevents, setIndustryevents] = useState([]);
  const [processing, setProcessing] = useState(false);
  const { setProgress } = useContext(configContext);

  // const events = [
  //   {
  //     id: 1,\
  //     url: "/events/e (1).jpeg",
  //     title: "Mechanical Alloying Of Nano Composites",
  //     location:
  //       "Gnanamani College of Technology, NH-7, A.K.Samuthiram, Pachal-PO, Namakkal-637 018.",
  //     link: "https://maps.app.goo.gl/YkGXCPB6QFGK92456",
  //     time: "11 AM to 12.15 PM",
  //     event_date: "7 September",
  //     city: "Pune",
  //   },
  //   {
  //     id: 2,
  //     url: "/events/e (2).jpeg",
  //     title: "National Level Technical Symposium And Workshop",
  //     city: "Delhi",
  //     location:
  //       "K.S.R. College of Engineering, K.S.R. Kalvi Nagar, Tiruchengode - 637 215, Namakkal (D.t)",
  //     event_date: "10 March",
  //     time: "11 AM to 1.00 PM",
  //     link: "https://maps.app.goo.gl/cfx8ZfaPosHVDt6w6",
  //   },
  //   {
  //     id: 3,
  //     url: "/events/e (3).jpeg",
  //     title: "A National Level Techno, Cultural Literacy and Sport Fest",
  //     city: "Delhi",
  //     event_date: "23rd to 25th October 2019",
  //     location: "Parvathapur, Uppal, Hydrabad - 500098",
  //     time: "2.00 PM to 4.00 PM",
  //   },
  //   {
  //     id: 4,
  //     url: "/events/e (4).jpeg",
  //     title: "A National Level Inter-College Technical Symposium",
  //     event_date: "10th January 2020",
  //     location:
  //       "KCG Nagar, Rajiv Gandhi Salai, Karapakkam, Chennai – 600 097. Tamil Nadu. India.",
  //     city: "Goa",
  //     time: "3.00 PM to 7.00 PM",
  //   },
  //   {
  //     id: 5,
  //     url: "/events/e (5).jpeg",
  //     title: "19th Technotsav 2020",
  //     event_date: "19th Feb 2020",
  //     city: "Delhi",
  //     location:
  //       "Facing Main Road, Sheriguda , Ibrahimpatan, R.R Dist. 501 510.",
  //     time: "1.00 PM to 5.00 PM",
  //   },
  //   {
  //     id: 6,
  //     url: "/events/e (6).jpeg",
  //     title: "A National Level Technical Symposium",
  //     city: "Delhi",
  //     event_date: "19th Feb, 2020",
  //     location:
  //       "Facing Main Road, Sheriguda , Ibrahimpatan, R.R Dist. 501 510.",
  //     time: "9.00 AM to 12.00 PM",
  //   },
  //   {
  //     id: 7,
  //     url: "/events/e (7).jpeg",
  //     title: "A National Level Technical Symposium",
  //     city: "Goa",
  //     location:
  //       "Facing Main Road, Sheriguda , Ibrahimpatan, R.R Dist. 501 510.",
  //     event_date: "19th & 20th Feb, 2020",
  //     time: "10.00 AM to 2.00 PM",
  //   },
  //   {
  //     id: 8,
  //     url: "/events/e (9).jpeg",
  //     title: "19th Techotsav 2020 Project Expo",
  //     city: "Delhi",
  //     event_date: "19th-20th Feb, 2020",
  //     location:
  //       "Facing Main Road, Sheriguda , Ibrahimpatan, R.R Dist. 501 510.",
  //     time: "2.00 PM to 4.00 PM",
  //   },
  //   {
  //     id: 9,
  //     url: "/events/e (10).jpeg",
  //     title: "National level Tech Fest",
  //     city: "Delhi",
  //     event_date: "30th August, 2019",
  //     location: "Perumalpattu, Veppampattu[R.S], Chennai - 602 024.",
  //     time: "3.00 PM to 5.00 PM",
  //   },
  //   {
  //     id: 10,
  //     url: "/events/e (11).jpeg",
  //     title: "4th National Level Technical Symposium",
  //     location: ".V.Nagar, Arasoor, Tisaiyanvilai (Via),Tirunelveli (Dist.)",
  //     city: "Goa",
  //     event_date: "21 August, 2017",
  //     time: "9.00 AM to 2.00 PM",
  //   },
  // ];

  useEffect(() => {
    getData();
    getIndustryData();
  }, []);

  const getData = () => {
    setProcessing(true);
    setProgress(10);
    server
      .get("/event/getallevent", {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setEvents(response.data);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
        setProcessing(false);
        setProgress(100);
      });
  };

  const getIndustryData = () => {
    setProcessing(true);
    setProgress(10);
    server
      .get("/event/getallind_event", {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setIndustryevents(response.data);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
        setProcessing(false);
        setProgress(100);
      });
  };

  const SearchData = (searchValue) => {
    server
      .get(`/event/searchallevent?search=${searchValue}`, {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setEvents(response.data);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
        setProcessing(false);
        setProgress(100);
      });
  };

  // search filter wise
  const FilterData = (event) => {
    const selectedValue = event.target.value;
    server
      .get(`/event/filter?filterByDate=${selectedValue}`, {
        headers: {
          "Content-Type": "application/json",
          // Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setEvents(response.data);
          setIndustryevents(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
        setProcessing(false);
        setProgress(100);
      });
  };

  return (
    <div className="container-xl  py-3" style={{ marginTop: "1rem" }}>
      <h3 className="text-center mb-3 text-uppercase">Discover Events</h3>
      <div className="row my-3">
        <div className="col-md-4">
          <select
            className="form-control"
            name=""
            id=""
            onChange={(e) => FilterData(e)} // Pass the event to FilterData
          >
            <option value="industry">Industry</option>
            <option value="institute">Institute</option>
            <option value="university">University</option>
          </select>
        </div>
        <div className="col-md-4 my-1">
          <input
            type="search"
            className="form-control"
            placeholder="Search"
            onChange={(e) => SearchData(e.target.value)}
          />
        </div>
        <div className="col-md-4 my-1">
          <select
            className="form-control"
            name=""
            id=""
            onChange={(e) => FilterData(e)} // Pass the event to FilterData
          >
            <option value="2days" defaultValue>
              Last 2 days
            </option>
            <option value="month" defaultValue>
              This Month
            </option>
            <option value="3months">Last 3 Months</option>
            <option value="6months">Last 6 Months</option>
          </select>
        </div>
      </div>
      <div className="row">
        {events &&
          events?.map((item) => {
            return (
              <>
                <div className="col-sm-4 col-md-4 col-lg-4 py-3 ">
                  <div
                    className="card card-style shadow "
                    style={{ height: "34rem" }}
                  >
                    <img
                      src={item.image}
                      alt=""
                      className="card-img-top "
                      width="271"
                      height="220"
                    />

                    <h5 className="text-center fw-bold p-2">{item.title}</h5>
                    <div className="p-3 ">
                      <div className="row">
                        <div className="col ">
                          <p className="row">
                            <div className="col-md-1">
                              <FcCalendar className="fs-4" />
                            </div>
                            <div className="col-md-10">{item.event_date}</div>
                          </p>
                          <p className="row">
                            <div className="col-md-1">
                              <FcClock className="fs-4" />
                            </div>
                            <div className="col-md-10">{item.time}</div>
                          </p>
                        </div>
                        <p className="row">
                          <a
                            href={item.location}
                            target="_blank"
                            className="col-md-1"
                          >
                            <CiLocationOn className="fs-4" />
                          </a>
                          <a
                            href={item.location}
                            target="_blank"
                            className="col-md-11"
                          >
                            <p>{item.address}</p>
                          </a>
                        </p>
                      </div>

                      {/* <p className="row">
                        <div className="col-md-10">
                          <b> Category</b> : {item.category}
                        </div>
                      </p> */}
                    </div>
                    <div className="d-flex text-center justify-content-center">
                      <NavLink
                        to={`/adminevents/${item.id}`}
                        className="btn banner text-white w-50 btn-sm rounded-5 rounded-0 "
                      >
                        VIEW
                      </NavLink>
                    </div>
                  </div>
                </div>
              </>
            );
          })}

        {industryevents &&
          industryevents
            ?.filter((item) => item.status === "Post")
            .map((item) => {
              return (
                <>
                  <div className="col-sm-4 col-md-4 col-lg-4 py-3 ">
                    <div
                      className="card card-style shadow "
                      style={{ height: "34rem" }}
                    >
                      <img
                        src={item.image}
                        alt=""
                        className="card-img-top "
                        width="271"
                        height="220"
                      />

                      <h5 className="text-center fw-bold p-2">{item.title}</h5>
                      <div className="p-3 ">
                        <div className="row">
                          <div className="col ">
                            <p className="row">
                              <div className="col-md-1">
                                <FcCalendar className="fs-4" />
                              </div>
                              <div className="col-md-10">{item.event_date}</div>
                            </p>
                            <p className="row">
                              <div className="col-md-1">
                                <FcClock className="fs-4" />
                              </div>
                              <div className="col-md-10">{item.time}</div>
                            </p>
                          </div>
                          <p className="row">
                            <a
                              href={item.location}
                              target="_blank"
                              className="col-md-1"
                            >
                              <CiLocationOn className="fs-4" />
                            </a>
                            <a
                              href={item.location}
                              target="_blank"
                              className="col-md-11"
                            >
                              <p>{item.address}</p>
                            </a>
                          </p>
                        </div>

                        {/* <p className="row">
                        <div className="col-md-10">
                          <b> Category</b> : {item.category}
                        </div>
                      </p> */}
                      </div>
                      <div className="d-flex text-center justify-content-center">
                        <NavLink
                          to={`/events/${item.id}`}
                          className="btn banner text-white w-50 btn-sm rounded-5 rounded-0 "
                        >
                          VIEW
                        </NavLink>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
      </div>
    </div>
  );
};

export default Events;
